import {Context} from "@reactivated";
import React from "react";

import "react-day-picker/dist/style.css";

export const ImperialCaloriesContext = React.createContext({
    isImperial: null as boolean | null,
    // oxlint-disable-next-line no-unused-vars
    setIsImperial: (value: boolean | null) => {},
});

export const useSiteContext = () => {
    return React.useContext(Context);
};

export const useMessages = () => {
    const context = useSiteContext();

    const createMessage = (message: string, level_tag: "success" | "info") => {
        const existing = context.messages.find(
            (m) => m.level_tag === level_tag && m.message === message,
        );

        if (existing == null) {
            context.setValue({
                ...context,
                messages: [
                    ...context.messages,
                    {message, level_tag, level: -1, from_server: false},
                ],
            });
        }
    };

    return {
        messages: context.messages.map((message, index) => ({...message, id: index})),
        remove: (id: number) =>
            context.setValue({
                ...context,
                messages: context.messages.filter((message, index) => index !== id),
            }),
        success: (message: string) => createMessage(message, "success"),
        info: (message: string) => createMessage(message, "info"),
    };
};

export const useStaticURL = () => {
    return useSiteContext().environment.STATIC_URL;
};
